<app-split-container>
  <div slot="left">
    <app-login-dialog-image
      *ngIf="!customMessage()"
      [title]="'login.screens.login.infoTitle' | translate"
      [subtitle]="'login.screens.login.infoSubtitle' | translate"
    >
      <app-login-image></app-login-image>
    </app-login-dialog-image>

    <div *ngIf="customMessage()" class="custom-message" [innerHTML]="customMessage() | safe"></div>
  </div>

  <div slot="right">
    <form id="login-form" [formGroup]="form" (submit)="login($event)">
      <formly-form
        [model]="formModel"
        [fields]="formFields[selectedForm]"
        [options]="formOptions"
        [form]="form"
      ></formly-form>

      <re-captcha
        #captcha="reCaptcha"
        *ngIf="loginAttempts() >= maxLoginAttempts()"
        (resolved)="resolvedCaptcha($event)"
        (errored)="errorCaptcha()"
        [errorMode]="'handled'"
      ></re-captcha>
    </form>

    <p *ngIf="externalUrl() !== ''">{{ 'login.externalLoginMessage' | translate }}</p>

    <opac-button [disabled]="form.invalid" class="submit-button" actionType="submit" form="login-form">
      {{ 'login.submit' | translate }}
    </opac-button>

    <opac-divider *ngIf="showForgotPassword() || allowSignup()">{{ 'general.or' | translate }}</opac-divider>

    <div class="links-container">
      <a
        *ngIf="showForgotPassword()"
        href="#"
        (click)="loadForgotPassword($event)"
        (keydown.enter)="loadForgotPassword($event)"
        (keydown.space)="loadForgotPassword($event)"
      >
        {{ 'login.screens.login.forgotPassword' | translate }}
      </a>

      <span *ngIf="allowSignup()">
        {{ 'login.screens.login.goToSignupText' | translate }}
        <a
          href="#"
          (click)="loadSignup($event)"
          (keydown.enter)="loadSignup($event)"
          (keydown.space)="loadSignup($event)"
        >
          {{ 'login.screens.login.goToSignupLink' | translate }}
        </a>
      </span>
    </div>
  </div>
</app-split-container>
